<template>
    <nav class="navbar navbar-expand-lg">
        <div class="container">
            <!-- Logo -->
            <router-link class="navbar-brand d-flex align-items-center" to="/">
                <img src="@/assets/images/logo.webp" class="logo-img" alt="Logo" />
            </router-link>

            <!-- Toggler for Mobile -->
            <button class="navbar-toggler" type="button" @click="toggleSidebar"
                :class="{ 'toggler-white': lightToggler }">
                <span class="navbar-toggler-icon"></span>
            </button>

            <!-- Navbar Links -->
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul :class="'navbar-nav ms-auto' + (this.$i18n.locale === 'ar' ? 'ms-auto' : 'me-auto')">
                    <li class="nav-item"><router-link class="nav-link" to="/">{{$t('navbar.main')}}</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/about_us">{{ $t('navbar.about_us') }}</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/our_services">{{ $t('navbar.our_services') }} </router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/quran_programs">
                        {{ $t('navbar.quran_programs') }}</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/last_news">{{ $t('navbar.blog') }}</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/contact"> {{ $t('navbar.contact_us') }}</router-link></li>
                </ul>
            </div>

            <!-- Right Side Items (Visible on Desktop) -->
            <div class="d-none d-lg-flex align-items-center gap-3 navbar-start">
                <!-- Search Icon -->
                <a href="#" class="search-icon">
                    <img src="@/assets/images/search.png" alt="">
                </a>

                <div class="break"></div>

                <!-- Buttons -->
                <a href="/dashboard/#/register" class="btn" style="color: white;">{{$t('navbar.register')}}</a>
                <a href="/dashboard/#/login" class="btn btn-primary ms-2">{{ $t('navbar.login') }}</a>

                <!-- Vision 2030 Logo -->
                <img src="@/assets/images/vision.webp" class="vision-logo" alt="Vision 2030 Logo">
            </div>
        </div>
    </nav>

    <!-- Sidebar for Mobile -->
    <div class="sidebar" :class="{ 'show-sidebar': isSidebarVisible }">
        <button class="close-btn" @click="toggleSidebar">×</button>
        <ul class="navbar-nav">
            <li class="nav-item"><router-link class="nav-link" to="/">{{$t('navbar.main')}}</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/about_us">{{ $t('navbar.about_us') }}</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/our_services">{{ $t('navbar.our_services') }} </router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/quran_programs">{{ $t('navbar.quran_programs') }} </router-link>
            </li>
            <li class="nav-item"><router-link class="nav-link" to="/last_news">{{$t('navbar.blog')}}</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/contact">{{ $t('navbar.contact_us') }}</router-link></li>
            <!-- Additional Mobile-Only Items -->
            <li class="nav-item">
                <a  href="/dashboard/#/register" class="nav-link">{{ $t('navbar.register') }}</a>
            </li>
            <li class="nav-item">
                <a href="/dashboard/#/login" class="nav-link">{{ $t('navbar.login') }}</a>
            </li>
        </ul>
    </div>

    <!-- Overlay for Mobile -->
    <div class="overlay" :class="{ 'show-overlay': isSidebarVisible }" @click="toggleSidebar"></div>
</template>

<script>
export default {
    props: ['lightToggler'],
    data() {
        return {
            isSidebarVisible: false, // Controls sidebar visibility
        };
    },
    methods: {
        toggleSidebar() {
            this.isSidebarVisible = !this.isSidebarVisible; // Toggle sidebar
        },
    },
}
</script>

<style scoped>

.toggler-white {
  border-color: white !important;
}

/* Make the icon white */
.toggler-white .navbar-toggler-icon {
  filter: invert(1);
}
.navbar {
    /* background: rgba(0, 0, 0, 0.1); */
    box-shadow: none !important;
    border: none !important;
    z-index: 2;
    /* Lower than buttons & links */

}

.nav-link {
    color: white;
    margin-inline-start: 15px;
}

.nav-link:hover {
    color: #BF9F35;
}

.logo-img {
    height: 100px;
    /* Adjust height as needed */
    width: auto;
    /* Keeps aspect ratio */
}

.vision-logo {
    width: 92px;
    height: 62px;
}

@media (max-width: 991.98px) {
    .sidebar {
        position: fixed;
        top: 0;
        right: -300px;
        /* Initially hidden */
        width: 300px;
        height: 100%;
        background-color: rgba(51, 51, 51, 0.9);
        box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);
        padding: 20px;
        transition: right 0.3s ease-in-out;
        z-index: 1050;
    }

    /* Show Sidebar */
    .show-sidebar {
        right: 0;
        /* Slide in */
    }

    /* Close Button */
    .close-btn {
        background: none;
        border: none;
        color: white;
        font-size: 30px;
        position: absolute;
        top: 15px;
        left: 15px;
        cursor: pointer;
    }

    /* Overlay Effect */
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease-in-out;
        z-index: 1040;
    }

    /* Show Overlay */
    .show-overlay {
        opacity: 1;
        visibility: visible;
    }

    .nav-link:hover,
    .close-btn:hover {
        color: #BF9F35 !important
    }
}

/* Hide Sidebar and Overlay on Larger Screens */
@media (min-width: 992px) {

    .sidebar,
    .overlay {
        display: none !important;
    }
}
</style>